import alert from '@/plugins/alert'
import { AssetBorrowRequest } from '@/plugins/api'
import { rangeRight } from 'lodash'

export default {
  namespaced: true,
  state: {
    loading: false,
    count: 0,
    pageText: '',
    itemsPerPage: 10,
    borrowSearchParams: {},
    totalItems: 0,
    borrows: []
  },
  actions: {
    async searchBorrowList({ commit, state, dispatch }, query) {
      const borrowSearchParams = {
        isDelete: false,
        _limit: state.itemsPerPage,
        ...query
      }
      commit('changeState', { borrowSearchParams })
      dispatch('requestPageSettings', {})
    },

    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage

      if (state.borrowSearchParams) {
        const borrowSearchParams = {
          ...state.borrowSearchParams,
          isDelete: false,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'createdAt:DESC'
        }

        const [totalItems, borrows] = await Promise.all([
          AssetBorrowRequest.count(borrowSearchParams),
          AssetBorrowRequest.search(borrowSearchParams)
        ])

        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            borrows,
            totalItems,
            itemsPerPage,
            borrowSearchParams
          })
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          const pages = rangeRight(1, page)
          for (let index = 0; index < pages.length; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      commit('changeState', { loading: false })
    },

    async createBorrow({ commit, state }, payload) {
      try {
        const created = await AssetBorrowRequest.create(payload)
        commit('changeState', {
          borrows: [created, ...state.borrows]
        })
        alert.success('Gửi yêu cầu mượn thành công')
        return created
      } catch (e) {
        alert.error(e)
      }
    },

    async approveBorrow({ commit }, id) {
      try {
        const updated = await AssetBorrowRequest.approve(id)
        commit('updateBorrow', updated)
        alert.success('Duyệt mượn thành công')
        return updated
      } catch (e) {
        alert.error(e)
      }
    },

    async rejectBorrow({ commit }, { id, rejectReason }) {
      try {
        const updated = await AssetBorrowRequest.reject(id, { rejectReason })
        commit('updateBorrow', updated)
        alert.success('Đã từ chối mượn')
        return updated
      } catch (e) {
        alert.error(e)
      }
    },

    async handoverBorrow({ commit }, { id, handoverNote }) {
      try {
        const updated = await AssetBorrowRequest.handover(id, { handoverNote })
        commit('updateBorrow', updated)
        alert.success('Bàn giao thiết bị thành công')
        return updated
      } catch (e) {
        alert.error(e)
      }
    },

    async returnBorrow({ commit }, { id, returnCondition, note }) {
      try {
        const updated = await AssetBorrowRequest.returnItem(id, { returnCondition, note })
        commit('updateBorrow', updated)
        alert.success('Xác nhận trả thiết bị thành công')
        return updated
      } catch (e) {
        alert.error(e)
      }
    },

    async removeBorrow({ commit }, id) {
      try {
        await AssetBorrowRequest.remove(id)
        commit('removeBorrow', id)
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    updateBorrow(state, data) {
      state.borrows = state.borrows.map(b => (b.id === data.id ? data : b))
    },
    removeBorrow(state, id) {
      state.borrows = state.borrows.filter(b => b.id !== id)
    },
    changeState(state, payload) {
      Object.assign(state, payload)
    }
  }
}
